import { makeDeleteRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';

const removeCloudCacheAccountUrl: string = 'ows/api/v1/CloudCacheConfig';

export async function removeCloudCacheAccount(): Promise<boolean> {
    let response = await makeDeleteRequest(removeCloudCacheAccountUrl, undefined, undefined, true);

    if (isSuccessStatusCode(response.status)) {
        return true;
    }

    return undefined;
}
